import { Box, BoxProps, chakra, Th as CTh } from '@chakra-ui/react';
import { Header } from '@tanstack/react-table';
import {
  ListSortColumn,
  ListSortColumnProps,
} from 'app/components/ChakraTableList';
import { deleteColumnSizing } from 'app/components/Core/StickyTable';
import { resizerSx } from 'app/components/Song/SongList/styles';

interface CustomThProps<T> extends BoxProps {
  isAvatar?: boolean;
  isOptions?: boolean;
  header?: Header<T, unknown>;
  sortColumnProps?: ListSortColumnProps<string>;
  tableKey: string;
}

const Label = ({ children }) => (
  <chakra.span
    sx={{
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }}
  >
    {children}
  </chakra.span>
);

export const Th = <T extends {}>({
  children,
  isAvatar,
  isOptions,
  header,
  sortColumnProps,
  sx,
  tableKey,
  ...props
}: CustomThProps<T>) => (
  <CTh
    as={Box}
    sx={{
      display: 'table-cell',
      textTransform: 'none',
      verticalAlign: 'middle',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      padding: '10px 12px',
      border: 'none',
      transition: 'opacity 200ms ease-in-out',
      _hover: {
        ' .resizer': {
          opacity: 1,
        },
        ' svg': {
          opacity: 1,
        },
      },
      ...(isAvatar ? { padding: 0, maxWidth: '52px', width: '52px' } : {}),
      ...(isOptions ? { maxWidth: '50px', width: '50px' } : {}),
      '&.gap': {
        px: 0,
      },
      ...sx,
    }}
    {...props}
  >
    {sortColumnProps ? (
      <ListSortColumn {...sortColumnProps}>
        <Label>{children}</Label>
      </ListSortColumn>
    ) : (
      <Label>{children}</Label>
    )}
    {header && (
      <Box
        {...{
          onDoubleClick: () => {
            header.column.resetSize();
            deleteColumnSizing(header.column.id, tableKey);
          },
          onMouseDown: header.getResizeHandler(),
          onTouchStart: header.getResizeHandler(),
          className: `resizer ${
            header.column.getIsResizing() ? 'isResizing' : ''
          }`,
        }}
        sx={resizerSx}
      >
        <Box />
      </Box>
    )}
  </CTh>
);
